module.exports = __webpack_public_path__ + "static/media/check.037bd768.svg";